import { c as _c } from "react/compiler-runtime";
import Badge from '@precis-digital/kurama/Badge';
import Chip, { type ChipProps } from '@precis-digital/kurama/Chip';
import Grid from '@precis-digital/kurama/Grid';
import Tooltip from '@precis-digital/kurama/Tooltip';
import Typography from '@precis-digital/kurama/Typography';
import { styled, useTheme } from '@precis-digital/kurama/utils';
import { useTranslation } from 'shared/translations';
import { capitalize } from 'shared/utils/stringFormatter';
import type { SeverityTypes } from 'shared/assetsBucket/recommendations';
import { getSeverityChipVariant, getSeverityMetaData } from '../utils';
type SeverityProps = Omit<ChipProps, 'variant'> & {
  type: SeverityTypes;
  label?: string;
  textVariant?: 'full' | 'compact';
};
const Severity = t0 => {
  const $ = _c(18);
  let label;
  let props;
  let t1;
  let type;
  if ($[0] !== t0) {
    ({
      type,
      label,
      textVariant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = label;
    $[2] = props;
    $[3] = t1;
    $[4] = type;
  } else {
    label = $[1];
    props = $[2];
    t1 = $[3];
    type = $[4];
  }
  const textVariant = t1 === undefined ? "full" : t1;
  const theme = useTheme();
  let t2;
  if ($[5] !== theme || $[6] !== type) {
    t2 = getSeverityMetaData(type, theme);
    $[5] = theme;
    $[6] = type;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const severityMetaData = t2;
  let t3;
  if ($[8] !== type) {
    t3 = getSeverityChipVariant(type);
    $[8] = type;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const variant = t3;
  if (textVariant === "full") {
    const t4 = label ?? severityMetaData.label;
    let t5;
    if ($[10] !== props || $[11] !== t4 || $[12] !== variant) {
      t5 = <Chip {...props} variant={variant} label={t4} />;
      $[10] = props;
      $[11] = t4;
      $[12] = variant;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    return t5;
  }
  const t4 = label != null ? label[0] : severityMetaData.label[0];
  let t5;
  if ($[14] !== props || $[15] !== t4 || $[16] !== variant) {
    t5 = <StyledCompactSeverityChip {...props} variant={variant} label={t4} />;
    $[14] = props;
    $[15] = t4;
    $[16] = variant;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
export const SeverityTooltip = t0 => {
  const $ = _c(23);
  const {
    children,
    type
  } = t0;
  const theme = useTheme();
  const {
    t
  } = useTranslation("recommendation");
  let t1;
  if ($[0] !== theme || $[1] !== type) {
    t1 = getSeverityMetaData(type, theme);
    $[0] = theme;
    $[1] = type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1.colorName) {
    t2 = <Badge color={t1.colorName} variant="lighter" />;
    $[3] = t1.colorName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== type) {
    t3 = capitalize(type);
    $[5] = type;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Typography variant="body2">{t3}</Typography>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <Grid container={true} alignItems="center" gap="8px">{t2}{t4}</Grid>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t || $[13] !== type) {
    t6 = t("severityTooltip", {
      severity: t(`severityLevels.${type}.name`),
      action: t(`severityLevels.${type}.action`)
    });
    $[12] = t;
    $[13] = type;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <Grid><Typography variant="body2">{t6}</Typography></Grid>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== children) {
    t8 = <Grid>{children}</Grid>;
    $[17] = children;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t7 || $[21] !== t8) {
    t9 = <Tooltip kind="multiline" title={t5} body={t7} placement="top-start">{t8}</Tooltip>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
const StyledCompactSeverityChip = styled(Chip)({
  width: '35px',
  height: '32px',
  minWidth: '35px'
});
export default Severity;